import { jsx as _jsx } from "react/jsx-runtime";
import { AnimatedFlame } from 'console/shared/components/features/animated-icons/flame';
import Flame from 'console/images/graph-control/thermostat-control-flame.svg';
import HeatRequest from 'console/images/thermostat-control/heat-request.svg';
import { HeatRequestAnim } from 'console/shared/components/features/animated-icons/heat-request';
import { AnimatedBell } from 'console/left-menu/header/icons/animated-icon/animated-bell';
import { NotificationsActive } from '@mui/icons-material';
import { AvatarInSettings, NotAnimatedAvatarInSettings } from './avatar-in-settings';
import { AnimElements } from 'features/account.settings/model/animation-elements';
export const getOptionAnimElements = (element) => {
    switch (element) {
        case AnimElements.avatar:
            return {
                title: 'Аватар',
                trueIcon: _jsx(AvatarInSettings, {}),
                falseElement: _jsx(NotAnimatedAvatarInSettings, {}),
            };
        case AnimElements.flame:
            return {
                title: 'Отопление',
                trueIcon: _jsx(AnimatedFlame, { fontSize: "1.5em" }),
                FalseIcon: Flame,
            };
        case AnimElements.heat_request:
            return {
                title: 'Запрос тепла',
                trueIcon: _jsx(HeatRequestAnim, { fontSize: "1.5em" }),
                FalseIcon: HeatRequest,
            };
        case AnimElements.bell_notification:
            return {
                title: 'Непрочитанные уведомления',
                trueIcon: _jsx(AnimatedBell, {}),
                FalseIcon: NotificationsActive,
            };
        case AnimElements.sensor_alarm:
            return {
                title: 'Сработка датчика',
            };
        case AnimElements.circuit_alarm:
            return {
                title: 'Авария котлового/отопительного контура',
            };
        case AnimElements.car_smoke:
            return {
                title: 'Выхлопные газы',
            };
        case AnimElements.car_autorun:
            return {
                title: 'Свет при автозапуске',
            };
        case AnimElements.car_lock:
            return {
                title: 'Свет при постановке/снятии охраны',
            };
        case AnimElements.car_siren:
            return {
                title: 'Сирена',
            };
        default:
            return { title: '' };
    }
};
